import React, { useEffect, useState, useMemo } from "react";
import { FilterableMultiSelect } from "carbon-components-react";
import { g100 } from "@carbon/themes";
import { groupBy, uniqBy } from "lodash";

/**
 * allItems: array like [{ properties: { truckPatent, time_category, type } }, ...]
 * filters:  { patentes: string[], time_categories: string[], types: string[] }
 * setFilters: setter from parent
 */
const MapControls = ({ allItems = [], filters, setFilters }) => {
  const [selectedPatente, setSelectedPatente] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedType, setSelectedType] = useState([]);

  // build dropdown sources (dedup + stable)
  const patenteItems = useMemo(() => {
    const rows = allItems
      .map(d => ({ text: String(d?.properties?.truckPatent ?? "") }))
      .filter(d => d.text);
    return uniqBy(rows, "text");
  }, [allItems]);

  const stateItems = useMemo(() => {
    const groups = Object.keys(groupBy(allItems, "properties.time_category"));
    return groups.filter(Boolean).map(text => ({ text }));
  }, [allItems]);

  const typeItems = useMemo(() => {
    const groups = Object.keys(groupBy(allItems, "properties.type"));
    return groups.filter(Boolean).map(text => ({ text }));
  }, [allItems]);

  // push to parent whenever a selection changes
  useEffect(() => {
    setFilters({
      patentes: selectedPatente.map(d => d.text),
      time_categories: selectedState.map(d => d.text),
      types: selectedType.map(d => d.text),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPatente, selectedState, selectedType]);

  const boxStyle = {
    backgroundColor: g100.background,
    border: `1px solid ${g100.borderStrong03}`,
    minWidth: 240,
    marginRight: 8,
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        width: "100%",
        alignItems: "center",
        padding: 8,
        backgroundColor: g100.background,
        color: g100.textPrimary,
      }}
    >
      <FilterableMultiSelect
        id="multi-patente"
        titleText="Patente"
        type="inline"
        items={patenteItems}
        itemToString={(item) => (item ? item.text : "")}
        onChange={({ selectedItems }) => setSelectedPatente(selectedItems)}
        style={boxStyle}
        selectionFeedback="top-after-reopen"
        direction="top"
        autoAlign
      />

      <FilterableMultiSelect
        id="multi-state"
        titleText="Estado"
        type="inline"
        items={stateItems}
        itemToString={(item) => (item ? item.text : "")}
        onChange={({ selectedItems }) => setSelectedState(selectedItems)}
        style={boxStyle}
        selectionFeedback="top-after-reopen"
      />

      <FilterableMultiSelect
        id="multi-tipo"
        titleText="Tipo de Vehículo"
        type="inline"
        items={typeItems}
        itemToString={(item) => (item ? item.text : "")}
        onChange={({ selectedItems }) => setSelectedType(selectedItems)}
        style={boxStyle}
        selectionFeedback="top-after-reopen"
        direction="top"
        autoAlign
      />
    </div>
  );
};

export default MapControls;
